import { Button as Btn, ThemeProvider, createTheme, CircularProgress } from "@mui/material"
import createPalette from "@mui/material/styles/createPalette";
import React from "react";
import { vars } from '../Variables'

const {
  primaryFont,
  primaryColor,
  primaryHoverColor,
  secondaryColor,
  secondaryHoverColor,
  blackColor,
  secondaryButtonColor,
  secondaryButtonHoverColor
} = vars;

export interface IButton {
  variant?: "text" | "outlined" | "contained";
  onClick?: () => void;
  children: React.ReactNode;
  size?: "large" | "medium" | "small";
  disabled?: boolean;
  fullWidth?: boolean;
  [x: string]: any;
}

declare module '@mui/material/styles' {
  interface Theme { }
  // allow configuration using `createTheme`
  interface ThemeOptions { }
}

const customPalette: any = createPalette({
  primary: {
    main: primaryColor,
    "100": primaryHoverColor
  },
  secondary: {
    main: secondaryColor,
    '100': secondaryHoverColor,
    '900': blackColor
  },
  info: {
    main: secondaryButtonColor,
    '100': secondaryButtonHoverColor,
  }
})

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: primaryFont,
          fontWeight: 500,
          fontSize: 13,
          lineHeight: '1',
          borderRadius: 50,
          paddingLeft: 20,
          paddingRight: 20,
          textTransform: 'none',
          letterSpacing: 'normal',
          height: 33,
          overflow: 'hidden',
          minWidth : "5rem"
        },

        sizeLarge: {
          height: 48,
          fontSize: 18,
          lineHeight: 18,
        },

        text: {
          color: customPalette.secondary[900],
        },

        outlinedPrimary: {
          color: customPalette.secondary.main,
          borderColor: customPalette.secondary.main,

          '&:hover': {
            borderColor: customPalette.secondary.main,
            background: customPalette?.secondary[100]
          }
        },

        outlinedSecondary: {
          color: customPalette.info.main,
          borderColor: customPalette.info.main,

          '&:hover': {
            borderColor: customPalette.info.main,
            background: customPalette?.info[100]
          }
        },

        containedPrimary: {
          background: customPalette.primary.main,

          '&:hover': {
            background: customPalette?.primary[100]
          }
        }
      },
    }
  }
});

export const Button: React.FC<IButton> = (props) => {
  const { variant = "contained", size = "medium", fullWidth = false, onClick, children, disabled, loading } = props;
  const progressSize = {
    "small" : 18,
    "medium" : 18,
    "large" : 20,
  }
  
  return (
    <ThemeProvider theme={theme}>
      <Btn
        {...props}
        size={size}
        fullWidth={fullWidth}
        disableElevation
        disabled={disabled || loading}
        onClick={onClick}
        variant={variant}
      >
        {!loading ? (
          children
        ) : (
          <CircularProgress size={progressSize[size]} sx={{ color: "gray" }} />
        )}
      </Btn>
    </ThemeProvider>
  );
}